import type { FC, ReactNode } from 'react';

export type IpcStatCardTone = 'default' | 'success' | 'primary' | 'muted' | 'destructive';

type Props = {
  label: string;
  value: ReactNode;
  meta?: ReactNode;
  icon?: ReactNode;
  tone?: IpcStatCardTone;
};

export const IpcStatCard: FC<Props> = ({ label, value, meta, icon, tone = 'default' }) => {
  const valueClass = tone === 'default' ? '' : `ipc-stat-card__value--${tone}`;
  return (
    <div className="ipc-stat-card">
      <div className="ipc-stat-card__body">
        <p className="ipc-stat-card__label">{label}</p>
        <p className={`ipc-stat-card__value ${valueClass}`.trim()}>{value}</p>
        {meta != null && meta !== '' && <p className="ipc-stat-card__meta">{meta}</p>}
      </div>
      {icon != null && <div className="ipc-stat-card__icon">{icon}</div>}
    </div>
  );
};
